"use client";

import React from "react";
import { Play, Star, Clock, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Skeleton } from "@/components/ui/skeleton";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function FeaturedContentGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {[...Array(8)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-3">
            <Skeleton className="aspect-video w-full rounded-md" />
            <Skeleton className="h-5 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex min-h-[200px] items-center justify-center rounded-md border border-border bg-muted/50 p-8 text-center">
        <p className="text-muted-foreground">
          Si è verificato un errore nel caricamento degli articoli. Riprova più tardi.
        </p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="flex min-h-[200px] items-center justify-center rounded-md border border-border bg-muted/50 p-8 text-center">
        <p className="text-muted-foreground">Nessun articolo disponibile al momento.</p>
      </div>;
  }
  return <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
      {posts.map((post, i) => <Link key={post.id} to={post.link || "#"} data-index={i} className="group relative flex flex-col overflow-hidden rounded-md bg-card text-card-foreground shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
          <AspectRatio ratio={16 / 9} className="overflow-hidden bg-muted">
            {post.featuredImage ? <img src={post.featuredImage} alt={post.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" /> : <div className="flex h-full w-full items-center justify-center bg-muted">
                <Play className="size-10 text-muted-foreground/30" />
              </div>}

            {}
            <div className="absolute inset-0 flex items-center justify-center bg-primary/40 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              <div className="flex flex-col items-center gap-2 transform translate-y-4 transition-transform duration-300 group-hover:translate-y-0">
                <div className="flex size-12 items-center justify-center rounded-md bg-secondary/90 backdrop-blur-sm">
                  <ChevronRight className="size-6 text-secondary-foreground" />
                </div>
                <span className="font-default text-sm font-semibold text-white drop-shadow-md">
                  Leggi Articolo
                </span>
              </div>
            </div>
          </AspectRatio>

          <div className="flex flex-col gap-2 p-4">
            <h3 className="font-default text-[18px] font-bold leading-tight text-foreground line-clamp-2">
              {post.title}
            </h3>
            <div className="flex items-center gap-4 text-xs text-muted-foreground">
              <div className="flex items-center gap-1">
                <Star className="size-3.5 fill-secondary text-secondary" />
                <span className="font-medium">{post.customFields?.rating || "Top"}</span>
              </div>
              <div className="flex items-center gap-1">
                <Clock className="size-3.5" />
                <span>{post.customFields?.duration || "5 min"}</span>
              </div>
            </div>
          </div>
        </Link>)}
    </div>;
}
export default function ArticlesGrid() {
  const wp_query_params = {
    post_type: "post",
    per_page: 8
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="260990" id="articles-grid" className="w-full bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto mb-8 flex w-full max-w-[1280px] items-end justify-between gap-4">
          <div>
            <h2 className="font-default text-3xl font-bold tracking-tight text-primary md:text-4xl">
              Approfondimenti e News
            </h2>
            <p className="mt-2 text-sm text-muted-foreground md:text-base font-default">
              Le ultime novità su visti, immigrazione e servizi legali internazionali.
            </p>
          </div>
          <Button variant="ghost" className="hidden sm:flex font-default text-primary hover:bg-accent" asChild>
            <Link to="/ExtrajudicialPage">
              Vedi tutti <ChevronRight className="ml-1 size-4" />
            </Link>
          </Button>
        </div>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 8
      }}>
          <FeaturedContentGrid />
        </PostsProvider>

        <div className="mt-8 flex justify-center sm:hidden">
          <Button variant="outline" className="w-full border-primary text-primary rounded-md" asChild>
            <Link to="/ExtrajudicialPage">
              Vedi tutti <ChevronRight className="ml-1 size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}